import React from "react";
import "./Buttons.scss";
import { useHistory } from "react-router-dom";

const Buttons = ({
	children,
	redirectTo,
	className,
	onClick,
	type,
	disabled,
}) => {
	const history = useHistory();

	const redirect = () => {
		history.push(redirectTo);
		window.scrollTo(0, 0);
		if (!disabled && (onClick !== null && onClick !== undefined) ) {
			console.log(onClick)
			onClick();
		}
	};

	return (
		<button
			onClick={type !== "submit" ? redirect : onClick}
			type={type}
			className={className + " btnComponent"}
		>
			{children}
		</button>
	);
};

export default Buttons;
